/**
 * @author      xinzhe.chai@zumper.com (Xinzhe Chai)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { Button as ChakraButton, ButtonProps } from '@chakra-ui/react'
import { useTheme } from '@emotion/react'
import React from 'react'

import { getSizeStyle, getSpaceSizeStyle, useResponsiveValue } from '../../helpers'

import * as styles from './styles'

interface Props extends ButtonProps {
  dataTestId?: string
}

export const SecondaryButton = ({
  children,
  dataTestId,
  isDisabled,
  size,
  tabIndex = 0,
  isLoading,
  spinner,
  onClick,
  style,
  ...rest
}: Props) => {
  const { name } = useTheme()
  const isSpaces = name === 'SPACES'
  const actualSize = useResponsiveValue(size) ?? 'md'

  return (
    <ChakraButton
      {...rest}
      css={[
        styles.button,
        size
          ? isSpaces
            ? getSpaceSizeStyle(actualSize)
            : getSizeStyle(actualSize)
          : getSizeStyle(actualSize),
        isSpaces ? styles.spacesButton : styles.secondaryButton,
      ]}
      data-testid={dataTestId}
      isDisabled={isDisabled}
      isLoading={isLoading}
      onClick={onClick}
      spinner={spinner}
      style={style}
      tabIndex={tabIndex}
    >
      {children}
    </ChakraButton>
  )
}
